import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import AppLayout from "../components/feature/AppLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ProductPage from "../pages/product/page";
import NovidadesPage from "../pages/novidades/page";
import CartPage from "../pages/sacola/page";
import CheckoutPage from "../pages/checkout/page";
import PainelPage from "../pages/painel/page";

const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/categoria/:slug",
        element: <CategoryPage />,
      },
      {
        path: "/novidades",
        element: <NovidadesPage />,
      },
      {
        path: "/produto/:id",
        element: <ProductPage />,
      },
      {
        path: "/sacola",
        element: <CartPage />,
      },
      {
        path: "/checkout",
        element: <CheckoutPage />,
      },
    ],
  },
  {
    path: "/painel",
    element: <PainelPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;